<div
  class="thumb-ai-card"
  [ngClass]="{
    'is-clickable': isSuccess,
    'is-loading': isLoading,
    'is-pending': isPending,
    'is-error': isError,
    'is-success': isSuccess,
    'has-actions': actionsEnabled,
    'is-pinned': isPinned,
    'is-landscape-loading': landscapeLoading
  }"
  [attr.title]="card?.errorMessage || card?.title || null"
  (click)="onCardClick()">
  <img *ngIf="isSuccess && thumbnailImageSrc" [src]="thumbnailImageSrc" [alt]="card.title">

  <button
    *ngIf="showSelectionCheck"
    type="button"
    class="select-check"
    [ngClass]="{ 'is-selected': selected, 'is-disabled': !selectable }"
    [disabled]="!selectable"
    [attr.aria-label]="selected ? 'Deselect model' : 'Select model'"
    [attr.title]="selectable ? null : 'Cannot save: missing portrait / landscape / title'"
    (click)="onSelectionToggle($event)">
    <svg *ngIf="!selected" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <circle cx="12" cy="12" r="10.5" stroke="currentColor" stroke-width="1.5"/>
    </svg>
    <svg *ngIf="selected" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <circle cx="12" cy="12" r="12" fill="white"/>
      <path d="M7 12.5L10.5 16L17 8.5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </button>

  <div class="thumb-ai-actions" *ngIf="actionsEnabled">
    <button
      *ngIf="isSuccess"
      type="button"
      class="action-btn action-btn-pin"
      [ngClass]="{ 'is-active': isPinned }"
      [attr.aria-label]="landscapeLoading ? 'Preparing pair preview' : (isPinned ? 'Unpin model' : 'Pin model')"
      (click)="onPinToggleClick($event)">
      <mat-spinner *ngIf="landscapeLoading" class="landscape-spinner" diameter="16" [strokeWidth]="2"></mat-spinner>
      <svg *ngIf="!landscapeLoading" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M11.4929 23C17.8446 23 23 17.8556 23 11.5C23 5.14438 17.8446 0 11.4929 0C5.15541 0 0 5.14438 0 11.5C0 17.8556 5.15541 23 11.4929 23ZM11.4923 21.5138C5.96144 21.5138 1.5 17.0344 1.5 11.5C1.5 5.96564 5.96144 1.48618 11.4923 1.48618C17.0233 1.48618 21.5 5.96564 21.5 11.5C21.5 17.0344 17.0233 21.5138 11.4923 21.5138Z" fill="currentColor"/>
        <path d="M7.0918 13.5524C7.0918 14.0654 7.41937 14.3932 7.96055 14.3932H10.7234V16.2172C10.7234 17.5567 11.2788 18.6398 11.4924 18.6398C11.7203 18.6398 12.2757 17.5567 12.2757 16.2172V14.3932H15.0385C15.5655 14.3932 15.9073 14.0654 15.9073 13.5524C15.9073 12.3981 14.9673 11.1298 13.3866 10.5456L13.1872 8.00902C14.0701 7.53876 14.7252 7.01149 15.0243 6.64099C15.181 6.44148 15.2522 6.22773 15.2522 6.05674C15.2522 5.68621 14.9673 5.41547 14.5401 5.41547H8.44475C8.03175 5.41547 7.74691 5.68621 7.74691 6.05674C7.74691 6.22773 7.81813 6.44148 7.97478 6.64099C8.27386 7.01149 8.92897 7.53876 9.79769 8.00902L9.61254 10.5456C8.03175 11.1298 7.0918 12.3981 7.0918 13.5524Z" fill="currentColor"/>
      </svg>
    </button>

    <button
      type="button"
      class="action-btn action-btn-delete"
      aria-label="Delete model"
      (click)="onDeleteClick($event)">
      <svg viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M11.4927 23C13.0696 23 14.5522 22.7023 15.9404 22.107C17.3286 21.5117 18.5524 20.6816 19.6117 19.6168C20.671 18.552 21.5005 17.3274 22.1003 15.9432C22.7001 14.5589 23 13.0779 23 11.5C23 9.92214 22.7001 8.44108 22.1003 7.05682C21.5005 5.67257 20.6686 4.44803 19.6044 3.38322C18.5403 2.3184 17.3165 1.48833 15.9331 0.892983C14.5497 0.297661 13.0648 0 11.4782 0C9.91104 0 8.43333 0.297661 7.04511 0.892983C5.6569 1.48833 4.43555 2.3184 3.38108 3.38322C2.3266 4.44803 1.49947 5.67257 0.899684 7.05682C0.299895 8.44108 0 9.92214 0 11.5C0 13.0779 0.299895 14.5589 0.899684 15.9432C1.49947 17.3274 2.32902 18.552 3.38833 19.6168C4.44764 20.6816 5.6714 21.5117 7.05962 22.107C8.44785 22.7023 9.92556 23 11.4927 23ZM11.4927 21.3011C10.1384 21.3011 8.86867 21.0495 7.68359 20.5461C6.49853 20.0427 5.45858 19.3409 4.56373 18.4406C3.66888 17.5404 2.96993 16.4974 2.46687 15.3116C1.96383 14.1257 1.71232 12.8552 1.71232 11.5C1.71232 10.1448 1.96383 8.87427 2.46687 7.68845C2.96993 6.50264 3.66888 5.4596 4.56373 4.55933C5.45858 3.65908 6.49611 2.95728 7.67634 2.45393C8.85656 1.95055 10.1239 1.69887 11.4782 1.69887C12.8423 1.69887 14.1168 1.95055 15.3019 2.45393C16.487 2.95728 17.5269 3.65908 18.4218 4.55933C19.3166 5.4596 20.0204 6.50264 20.5331 7.68845C21.0458 8.87427 21.3022 10.1448 21.3022 11.5C21.3022 12.8552 21.0483 14.1257 20.5404 15.3116C20.0325 16.4974 19.3311 17.5404 18.4363 18.4406C17.5414 19.3409 16.5015 20.0427 15.3164 20.5461C14.1313 21.0495 12.8568 21.3011 11.4927 21.3011Z" fill="currentColor"/>
        <path d="M6.87815 12.3567H16.1072C16.3877 12.3567 16.6151 12.2841 16.7892 12.1389C16.9634 11.9937 17.0504 11.7904 17.0504 11.5291C17.0504 11.258 16.9658 11.0475 16.7965 10.8974C16.6272 10.7474 16.3974 10.6724 16.1072 10.6724H6.87815C6.58792 10.6724 6.35574 10.7474 6.18161 10.8974C6.00748 11.0475 5.92041 11.258 5.92041 11.5291C5.92041 11.7904 6.00989 11.9937 6.18886 12.1389C6.36785 12.2841 6.59761 12.3567 6.87815 12.3567Z" fill="currentColor"/>
      </svg>
    </button>
  </div>

  <div class="thumb-ai-status" *ngIf="isLoading || isPending || isError">
    <mat-spinner *ngIf="isLoading || isPending" diameter="34" [strokeWidth]="3"></mat-spinner>

    <div class="error-state" *ngIf="isError">
      <mat-icon class="error-icon" svgIcon="exclamation-mark-icon"></mat-icon>
      <button *ngIf="canRetry" type="button" class="retry-btn" (click)="onRetryClick($event)">Retry</button>
    </div>
  </div>

  <div class="thumb-ai-meta" [ngClass]="{ 'always-visible': !isSuccess }">
    <h3 *ngIf="card.title">{{ card.title }}</h3>
    <span *ngIf="statusText">{{ statusText }}</span>
  </div>
</div>
